export default __webpack_public_path__ + "static/media/Close.2a25875c.svg";